import { z } from 'zod/v4';

/**
 * HI severity scale: -1 (NOT_CONF) … 6 (MAINTENANCE); "Not OK" = 3|4|5.
 */
export const SeverityDTO = z.number().int().min(-1).max(6);

export type Severity = z.infer<typeof SeverityDTO>;